import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-touchspin';
import 'bootstrap-filestyle.min';